export default "__VITE_ASSET__BXwEPPZk__"